import React from "react"
import { Jumbotron, HeadNotification } from "../../components"
import bgimage from "../../assets/img/bgimage.png"
import Content from "./Content"

function NewsDetail() {
  return (
    <>
      <Jumbotron bgImage={bgimage} />
      <HeadNotification />
      <Content />
    </>
  )
}

export default NewsDetail
